












































import { Component, Prop, Vue } from 'vue-property-decorator'

type TextSize = 'medium' | 'large' | 'small' | 'smaller'

type TextColor = 'white' | 'purple' | 'marine' | 'black'

type BorderColor = 'white' | 'marine' | 'gray' | 'silver' | 'none'

type ButtonBorder = 'sm' | 'md' | 'lg' | 'full' | 'none'

type weightFont = 'normal' | 'medium' | 'bold'

type ButtonColor = 'marine' | 'purple' | 'white' | 'green' | 'mediumPurple' | 'transparent' | 'blue'

type ButtonSize = 'small' | 'smaller' | 'medium' | 'mediumPlus' | 'thinPlus' | 'thin' | 'thinner' | 'large' | 'larger' | 'largest'

@Component
export default class CommonButton extends Vue {
  @Prop({ type: String }) private rightIcon!: string

  @Prop({ type: String }) private icon!: string

  @Prop({ default: 'button', type: String }) private type!: string

  @Prop({ default: false, type: Boolean }) private disabled!: boolean

  @Prop({ default: true, type: Boolean }) private loaded!: boolean

  @Prop({ default: 'medium', type: String }) private text!: TextSize

  @Prop({ default: 'medium', type: String }) private size!: ButtonSize

  @Prop({ default: 'marine', type: String }) private color!: ButtonColor

  @Prop({ default: 'white', type: String }) private border!: BorderColor

  @Prop({ default: 'white', type: String }) private textColor!: TextColor

  @Prop({ default: 'none', type: String }) private radius!: ButtonBorder

  @Prop({ default: 'normal', type: String }) private font!: weightFont

  @Prop({ default: false, type: Boolean }) private truncate!: boolean

  get textSize(): string {
    switch (this.text) {
      case 'large':
        return 'text-15'
      case 'small':
        return 'text-13'
      case 'smaller':
        return 'text-12'
      default:
        return 'text-14'
    }
  }

  get buttonBorder(): string {
    switch (this.radius) {
      case 'sm':
        return 'rounded'
      case 'md':
        return 'rounded-md'
      case 'lg':
        return 'rounded-lg'
      case 'full':
        return 'rounded-full'
      case 'none':
        return 'rounded-none'
      default:
        return ''
    }
  }

  get textColors(): string {
    switch (this.textColor) {
      case 'purple':
        return 'text-crm-1'
      case 'marine':
        return 'text-crm-2'
      case 'black':
        return 'text-black'
      default:
        return 'text-crm-7'
    }
  }

  get borderColor(): string {
    switch (this.border) {
      case 'marine':
        return 'border border-crm-2'
      case 'gray':
        return 'border border-dark-5'
      case 'silver':
        return 'border border-crm-5'
      case 'none':
        return 'border-none'
      default:
        return 'border-none'
    }
  }

  get colorClassname(): string {
    switch (this.color) {
      case 'purple':
        return 'bg-crm-1'
      case 'white':
        return 'bg-crm-4'
      case 'green':
        return 'bg-crm-10'
      case 'mediumPurple':
        return 'bg-crm-9'
      case 'transparent':
        return 'bg-opacity-0'
      case 'blue':
        return 'bg-crm-19'
      default:
        return 'bg-crm-2'
    }
  }

  get fontWeight(): string {
    switch (this.font) {
      case 'normal':
        return 'font-normal'
      case 'medium':
        return 'font-medium'
      case 'bold':
        return 'font-bold'
      default:
        return 'font-normal'
    }
  }

  onClick(e: Event): void {
    if (!this.disabled && this.loaded) {
      this.$emit('click', e)
    }
  }
}
